<!--侧边栏-->
<template>
  <div class="side-bar fl no-print" :class="{ w50: isToggle }">
    <!--侧边栏顶部信息-->
    <div class="side-bar-top">
      <div class="logo h60" @click="linkToHome">
        <span class="logo-title" :class="{ hidden: isToggle }">医生工作站4.0</span>
      </div>
      <div class="side-bar-personal">
        <div class="side-bar-personal-icon" :class="{ hidden: isToggle }">
          <!--<img class="personal-icon" src="../../images/doctor-pic.png" >-->
          <img class="personal-icon" :src="docAvatar" />
        </div>
        <p
          class="side-bar-personal-info marginT10 flex jcc"
          :class="{ hidden: isToggle }"
        >
          {{ userInfo.doc.docName }}
        </p>
        <p
          class="side-bar-personal-title marginT5 green-color flex jcc"
          :class="{ hidden: isToggle }"
        >
          {{ userInfo.doc.docTitle }}
        </p>
        <p
          class="side-bar-personal-title marginT5 green-color flex jcc"
          :class="{ hidden: isToggle }"
        >
          {{ userInfo.doc.hosName }}
        </p>
        <p
          class="side-bar-personal-title marginT5 green-color flex jcc"
          :class="{ hidden: isToggle }"
        >
          {{ userInfo.doc.deptName }}
        </p>
      </div>
    </div>
    <!--侧边栏列表-->
    <!-- <div class="side-bar-list">
          <div
            @click="clickItem('wlmz')"
            :class="['side-bar-item', 'h49', 'side-bar-icon-rwzx', { 'item-click': clickName=='wlmz' }]"
          >
            <router-link to="/main" class="side-bar-link">
              <span
                :class="[{ 'hidden': isToggle }, [ clickName=='wlmz'?'item-title-click': 'side-bar-item-title'], 'fl']"
              >网络门诊</span>
            </router-link>
          </div>
          <div
            @click="clickItem('hzqy')"
            :class="['side-bar-item', 'h49', 'side-bar-icon-rwzx', { 'item-click': clickName=='hzqy' }]"
          >
            <router-link to="/main/management-contract" class="side-bar-link">
              <span
                :class="[{ 'hidden': isToggle }, [ clickName=='wlmz'?'item-title-click': 'side-bar-item-title'], 'fl']"
              >患者签约</span>
            </router-link>
          </div>
        </div> -->

    <div class="sign" @click="sign" v-if="userInfo.doc.isTencentAutoSign!=='1'">开通医生电子签名</div>

    <el-menu
      :default-active="defaultActive"
      background-color="#132f5e"
      text-color="#ffffff"
      style="width: 100%"
      router
    >
      <el-menu-item
        index="/main"
        v-if="docTitle != '药师' && hosId != '1100000060'"
        >网络门诊</el-menu-item
      >
      <el-menu-item
        index="/main/medicalTemplateList"
        v-if="hosId != '1100000060'"
        >病历模板管理</el-menu-item
      >
      <el-submenu index="3" v-if="hosId != '1100000060'">
        <!-- v-if="docTitle != '药师' && userRecipeAuthority != ''&&hosId!='1100000060'" -->
        <template slot="title">处方/病历管理</template>
        <!-- <el-menu-item index="/main/e-prescription">电子处方</el-menu-item> -->
        <el-menu-item index="/main/prescription-list" v-if=" hosId != '1100000060'&&docTitle != '药师'">处方列表 </el-menu-item>
        <el-menu-item index="/main/medicalRecord" v-if=" hosId != '1100000060'&&docTitle != '药师'">病历列表 </el-menu-item>
        <!-- v-if="['OPEN', 'OPEN,AUDIT'].includes(userRecipeAuthority)" -->
        <el-menu-item
          v-if="docTitle == '药师' && hosId != '1100000060'"
          index="/main/prescription-check"
          >处方审核
        </el-menu-item>
        <!-- v-if="['AUDIT', 'OPEN,AUDIT'].includes(userRecipeAuthority)" -->
      </el-submenu>
      <el-submenu index="2" v-if="docTitle != '药师' && hosId != '1100000060'">
        <template slot="title">患者签约</template>
        <el-menu-item index="/main/management-contract">签约管理</el-menu-item>
        <el-menu-item index="/main/management-service-reservation"
          >服务预约管理</el-menu-item
        >
      </el-submenu>
      <el-menu-item
        index="/main/patientQuery"
         v-if="isShowPatQuery == '1'&&docTitle != '药师'"
        >患者查询</el-menu-item
      >
      <el-submenu index="4" v-if="docTitle == '药师'&&hosId!='1100000060'">
        <!--  -->
        <!--  -->
        <template slot="title" >药房管理</template>
        <el-menu-item index="/main/pharmacy-workstation"
        v-if="docTitle == '药师'&&hosId!='1100000060'"
          >药房工作站</el-menu-item
        >
        <el-menu-item index="/main/pharmacy-drugs" v-if="docTitle == '药师'&&hosId!='1100000060'">药房药品</el-menu-item>
      </el-submenu>
      <!-- <el-submenu index="6" v-if="hosId!='1100000060'">
        <template slot="title">开处方</template>
        <el-menu-item
          index="/main/Prescribing"
          >开处方
        </el-menu-item>
      </el-submenu> -->
      <el-submenu index="7" v-if="hosId == '1100000060'">
        <template slot="title">健康管理</template>
        <el-menu-item index="/main/memberList" v-if="docTypeName=='FIRST_LINE_DOCTOR'">健康会员 </el-menu-item>
        <el-menu-item index="/main/healthyProgramme" v-if="docTypeName=='SECOND_LINE_DOCTOR'">健康方案标签 </el-menu-item>
        <el-menu-item index="/main/questionnaireList">健康问卷管理 </el-menu-item>
      </el-submenu>

<!--      互联网医院验收添加-->
      <el-menu-item index="/main/quality-control">病历质控结果</el-menu-item>
      <!--      互联网医院验收添加 end-->
    </el-menu>
    <!--<div class="side-browser">-->
    <!--<p>-推荐使用<a style="color:#fff;" href="https://www.baidu.com/link?url=5qzsiSDzRsfe4NoPBHAOFys4hC0lu0eyyawmOUjcl-qewhKYTtBXxsw6eSYflBz_roTjVGE6WIYdwbzMyi4dkmKvkKx4kDJq1mnyb-8QiOe&wd=&eqid=c5abeca60003eafc00000004597555dc"  target="_blank">谷歌</a>浏览器-</p>-->
    <!--</div>-->
  </div>
</template>
<style>
</style>
<script>
import { Message, Loading } from "element-ui";
export default {
  props: ["clientH", "isToggle", "data"],
  data: function () {
    return {
      docTypeName: JSON.parse(sessionStorage.getItem("loginInfo")).doc.docTypeName,
      userInfo: JSON.parse(sessionStorage.getItem("loginInfo")),
      //userName: JSON.parse(sessionStorage.getItem("loginInfo")).docName,
      docTitle: JSON.parse(sessionStorage.getItem("loginInfo")).doc.docTitle,
      isShowPatQuery: JSON.parse(sessionStorage.getItem("loginInfo")).doc
        .isShowPatQuery,
      docType: JSON.parse(sessionStorage.getItem("loginInfo")).doc.docType,
      docAvatar: JSON.parse(sessionStorage.getItem("loginInfo")).doc.docAvatar
        ? JSON.parse(sessionStorage.getItem("loginInfo")).doc.docAvatar
        : require("../../../images/doc-default-icon.png"),
      defaultActive: "/main",
      userRecipeAuthority: "",
      hosId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.hosId,
    };
  },
  computed: {
    clickName: function () {
      return this.$store.state.clickName;
    },
    isGetNewMsg_twzx: function () {
      // 图文咨询红点
      return this.$store.state.isGetNewMsg_twzx;
    },
    isGetNewMsg_wdhz: function () {
      // 我的患者红点
      return this.$store.state.isGetNewMsg_wdhz;
    },
    isGetNewMsg_spwz: function () {
      // 视频问诊红点
      return this.$store.state.isGetNewMsg_spwz;
    },
    isGetNewMsg_ychz: function () {
      // 远程会诊红点
      return this.$store.state.isGetNewMsg_ychz;
    },
    isGetNewMsg_hyzx: function () {
      // 会议中心红点
      return this.$store.state.isGetNewMsg_hyzx;
    },
  },
  watch: {
    $route(route) {
      this.defaultActive = route.path;
    },
    // $route(newV, oldV) {
    // }
  },
  mounted() {
    this.userRecipeAuthority = this.userInfo.doc.recipeAuthority
      ? this.userInfo.doc.recipeAuthority.docRecipeAuthority
      : "";
  },
  methods: {
   async sign() {
     console.log("==========sign========>",)
     let instance = Loading.service({text: '加载中'});
     let res = await this.$http(
         "smarthos.tencent.pdf.auto.sign.enable",
         {
           docId: this.userInfo.doc.id,
         }
     );
     instance?.close();
     console.log("===========res=======>", res)
     if (res.code == 0) {
       Message({
         showClose: true,
         message: '开通自动签名链接已下发， 请在短信链接中完成认证操作',
         type: "success"
       });
     } else {
       Message({
         showClose: true,
         message: res.msg,
         type: "error"
       });
     }
   },
    linkToHome: function () {
      this.$router.push("/main");
    },
    clickItem: function (itemName) {
      this.$store.dispatch("changeSideItem", itemName);
      window.localStorage.setItem("clickName", itemName);
    },
  },
};
</script>

<style lang="scss">

.sign{
  color: #fff;
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
}

.side-bar {
  height: 100%;
  min-height: 100vh;

  &-item-title {
    color: #fff;
  }
}
</style>
